export default __webpack_public_path__ + "static/media/L'oeil derrière le miroir.c00e11ea.jpg";